/* eslint-disable import/prefer-default-export */
export const yieldTypes = {
  OFFERS: 'offers',
  DEPOSITED: 'deposited',
  RECEIVED: 'received',
};

export const MODAL_SCREENS = {
  TOTAL_BALANCE_POPUP_INFO: 'total_balance_popup_info',
  DEPOSIT: 'deposit',
  CONFRIM_DEPOSIT: 'confirm_deposit',
  DEPOSITED_SUCCESS: 'deposited_success',
  DEPOSIT_DETAILS: 'deposit_details',
  RECEIVED_DETAILS: 'received_details',
};
